const locale = {
    placeholder: 'Vælg tid',
    rangePlaceholder: ['Starttidspunkt', 'Sluttidspunkt'],
};
export default locale;
